import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { cn } from "./cn.js";
export function Scrim({ className, ...rest }) {
    return _jsx("div", { className: cn("fwfa-scrim", className), ...rest });
}
export function ModalActions({ className, ...rest }) {
    return _jsx("div", { className: cn("fwfa-modal-actions", className), ...rest });
}
const FOCUSABLE = 'a[href],button:not([disabled]),textarea:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
export function Modal({ open, onClose, labelledBy, closeOnBackdrop = true, closeOnEscape = true, sheet = false, fullscreen = false, className, children, ...rest }) {
    const dialogRef = useRef(null);
    useEffect(() => {
        if (!open)
            return;
        const previouslyFocused = document.activeElement;
        const dialog = dialogRef.current;
        const focusable = () => dialog
            ? Array.from(dialog.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null)
            : [];
        (focusable()[0] ?? dialog)?.focus();
        const onKeyDown = (event) => {
            if (closeOnEscape && event.key === "Escape") {
                event.stopPropagation();
                onClose();
                return;
            }
            if (event.key !== "Tab")
                return;
            const items = focusable();
            if (items.length === 0) {
                event.preventDefault();
                return;
            }
            const first = items[0];
            const last = items[items.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            }
            else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        };
        document.addEventListener("keydown", onKeyDown, true);
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onKeyDown, true);
            document.body.style.overflow = previousOverflow;
            previouslyFocused?.focus?.();
        };
    }, [open, onClose, closeOnEscape]);
    if (!open)
        return null;
    return createPortal(_jsx(Scrim, { onMouseDown: (event) => {
            if (closeOnBackdrop && event.target === event.currentTarget)
                onClose();
        }, children: _jsx("div", { ref: dialogRef, className: cn("fwfa-modal", className), role: "dialog", "aria-modal": "true", "aria-labelledby": labelledBy, "data-modal": fullscreen ? "fullscreen" : sheet ? "sheet" : undefined, tabIndex: -1, ...rest, children: children }) }), document.body);
}
//# sourceMappingURL=Modal.js.map